import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { BEFOREUNLOAD } from 'common/constants/SharedConstants';
import OrderSummaryViews from 'organisms/orderSummaryViews/container/orderSummaryViews';
import {
  orderDetailsDefaultValue,
  prepareOrderSummaryContentData,
  getToastMsgForRemake,
} from 'common/utilities/orderDetailsUtils';
import {
  dispatchPickupOrderCancelPostOrderAction,
  dispatchGetContentHelpCallAction,
  dispatchGetTendersContent,
  getDeliveryOrderStatusTracking,
  resetReducers,
  dispatchPickupOrderCheckInRequestAction,
} from 'common/utilities/orderProcessingSummaryUtils';
import OrderProcessingSummaryHOC from 'components/OrderProcessingSummaryHOC';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { selectContentfulResponse } from '@kfc-global/react-shared/redux/Slices/ContentfulSlice';
import isEmpty from 'lodash/isEmpty';

const OrderSummary = props => {
  const dispatch = useDispatch();

  const [orderDetails, setOrderDetails] = useState(orderDetailsDefaultValue);
  const orderSummaryContent = useAppSelector(selectContentfulResponse) ?? {};

  /*********************************************************************
   *  updateSetOrderDetails - useCallback
   *  param
   *  console.debug('updateSetOrderDetails => ', param);
   *********************************************************************/
  const updateSetOrderDetails = useCallback(param => {
    setOrderDetails && setOrderDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  /*********************************************************************
   * fetch order summary content data from reducer
   *********************************************************************/
  useEffect(() => {
    !isEmpty(orderSummaryContent?.orderTracking) &&
      prepareOrderSummaryContentData(orderSummaryContent?.orderTracking, orderDetails, updateSetOrderDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.orderStatus, orderSummaryContent?.orderTracking]);

  useEffect(() => {
    orderDetails?.orderSummarycontentData && getToastMsgForRemake(orderDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.orderSummarycontentData]);

  /*********************************************************************
   *  useEffect
   *   console.debug('useEffect [] => ');
   *********************************************************************/
  useEffect(() => {
    window.scrollTo(0, 0);
    window.removeEventListener(BEFOREUNLOAD, () => resetReducers({ dispatch, beforeUnload: true, orderDetails }), true);
    window.addEventListener(BEFOREUNLOAD, () => resetReducers({ dispatch, beforeUnload: true, orderDetails }), true);

    dispatchGetTendersContent(dispatch);
    dispatchGetContentHelpCallAction(dispatch);

    return () => {
      window.removeEventListener(
        BEFOREUNLOAD,
        () => resetReducers({ dispatch, beforeUnload: true, orderDetails }),
        true,
      );
      resetReducers({ dispatch, orderDetails });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*********************************************************************
   *  useEffect
   *  console.debug('useEffect orderDetails?.retryCountForGetOrderTrackingStatus => ',orderDetails?.retryCountForGetOrderTrackingStatus,);
   *  console.debug('useEffect return orderDetails?.retryCountForGetOrderTrackingStatus => ',orderDetails?.retryCountForGetOrderTrackingStatus,);
   *********************************************************************/
  useEffect(() => {
    getDeliveryOrderStatusTracking({
      dispatch,
      orderDetails,
      updateSetOrderDetails,
    });
    return () => {
      orderDetails?.dispatchDeliveryOrderTrackerTimer && clearTimeout(orderDetails?.dispatchDeliveryOrderTrackerTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.retryCountForGetOrderTrackingStatus]);

  /*********************************************************************
   * useEffect
   * pickupOrderCancelOrder
   *********************************************************************/
  useEffect(() => {
    orderDetails?.pickupCancelOrder &&
      dispatchPickupOrderCancelPostOrderAction({
        dispatch,
        orderDetails,
        updateSetOrderDetails,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.pickupCancelOrder]);

  /*********************************************************************
   * useEffect
   * isPickupOrderUserConfirmedToCheckIn
   *********************************************************************/
  useEffect(() => {
    orderDetails?.isPickupOrderUserConfirmedToCheckIn &&
      dispatchPickupOrderCheckInRequestAction({
        dispatch,
        orderDetails,
        updateSetOrderDetails,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.isPickupOrderUserConfirmedToCheckIn]);

  return (
    <OrderProcessingSummaryHOC {...props} orderDetails={orderDetails} updateSetOrderDetails={updateSetOrderDetails}>
      <OrderSummaryViews {...props} orderDetails={orderDetails} updateSetOrderDetails={updateSetOrderDetails} />
    </OrderProcessingSummaryHOC>
  );
};
export default OrderSummary;
